// @ts-nocheck
import { Component, Input, SimpleChanges } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
    selector: 'lbca-cloud-save',
    templateUrl: './cloud-save.component.html',
    imports: [NgClass]
})
export class CloudSaveComponent {
	@Input()
	controlCloud: 'saved' | 'saving' | 'error' | 'init' = 'init';

	public savedFinish: boolean = false;

	constructor() {}

	ngOnChanges(change: SimpleChanges) {
		if (change['controlCloud']) {
			this.controlCloud = change['controlCloud'].currentValue;

			if (this.controlCloud === 'saved') {
				this.savedFinish = false;

				setTimeout(() => {
					this.savedFinish = true;
				}, 1400);
			}
		}
	}
}
